import axios from 'axios';
import store from './redux/configureStore';
import { setSnackbar } from './redux/ducks/snackbar';
import { setErrorSavingFlag } from './redux/ducks/registroMateriales';

export const BASE_URL = process.env.REACT_APP_API_URL || '';

const http = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

http.interceptors.request.use((config) => {
    try {
        // react-oidc-context uses oidc-client-ts which stores user data in sessionStorage
        // The key format is: oidc.user:{authority}:{client_id}
        // We'll search for any oidc.user key to find the token
        let accessToken = null;

        for (let i = 0; i < sessionStorage.length; i += 1) {
            const key = sessionStorage.key(i);
            if (key && key.startsWith('oidc.user:')) {
                const userString = sessionStorage.getItem(key);
                if (userString) {
                    const user = JSON.parse(userString);
                    if (user?.access_token) {
                        accessToken = user.access_token;
                        break;
                    }
                }
            }
        }

        if (accessToken) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
    } catch (error) {
        console.error('Error getting access token from storage:', error);
    }
    return config;
}, null, { synchronous: true });
export default http;

http.interceptors.response.use(
    (response) => response,
    (error) => {
        switch (error.response.status) {
        case 400:
            console.log(error.response.data);
            if (typeof error.response.data === 'string') {
                store.dispatch(setSnackbar(true, 'error', error.response.data));
            } else {
                store.dispatch(setSnackbar(true, 'error', error.response.data.message));
            }
            break;
        case 401:
        case 403:
            store.dispatch(setErrorSavingFlag(1));
            store.dispatch(setSnackbar(true, 'error', 'Acceso no permitido'));
            break;
        case 500:
            if (error.response.data.message === 'Invalid password') {
                store.dispatch(setSnackbar(true, 'error', 'Password incorrecto'));
            } else {
                store.dispatch(setSnackbar(true, 'error', 'Error en el sistema'));
            }
            break;
        default:
        }
    },
);
